let apiRootUrl = window['env']['apiUrl'];
let authUrl = window['env']['authUrl'];
let ndviWorkerUrl = window['env']['ndviWorkerUrl'];
let tracksUrl = window['env']['tracksUrl'];

export const environment = {
  production: true,
  apiRoot: apiRootUrl,
  mapsApiKey: 'AIzaSyDYIXd9qqfw3osVqKYVmMYgn8FSVg_gDlM',
  workerRoot: ndviWorkerUrl || 'https://ndvi.agrichain.com.ua',
  authServerUrl: authUrl,
  tracksUrl: tracksUrl,
  tokenKey: 'token',
  odataUrl: `${apiRootUrl}/odataconnector/api/OData.svc`
};
